import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAvailability = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.375 8H16.625C16.8313 8 17 8.16875 17 8.375V16.5C17 17.3281 16.3281 18 15.5 18H4.5C3.67188 18 3 17.3281 3 16.5V8.375C3 8.16875 3.16875 8 3.375 8ZM17 6.625V5.5C17 4.67188 16.3281 4 15.5 4H14V2.375C14 2.16875 13.8313 2 13.625 2H12.375C12.1687 2 12 2.16875 12 2.375V4H8V2.375C8 2.16875 7.83125 2 7.625 2H6.375C6.16875 2 6 2.16875 6 2.375V4H4.5C3.67188 4 3 4.67188 3 5.5V6.625C3 6.83125 3.16875 7 3.375 7H16.625C16.8313 7 17 6.83125 17 6.625Z",
		fill: "#0D2976"
	})
});
export default SvgAvailability;
